<script setup lang="ts">
import { PropType, shallowRef, toRefs } from "vue";
import { useApiClient } from "@/api/client";
import ModuleLoading from "@/ui/components/loading/moduleLoading.vue";
import {
	required,
	maxLength,
	titleInputRules,
} from "@/ui/validation/validationRules";
import { useI18n } from "vue-i18n";
import { toastApiResult } from "@/toaster";

const { t } = useI18n();

const props = defineProps({
	role: {
		type: Object as PropType<App.Data.RoleDO>,
		require: true,
	},
});

const { role } = toRefs(props);
const isSaving = shallowRef(false);
const emit = defineEmits(["update-role"]);

const updateRole = async () => {
	isSaving.value = true;

	const response = await toastApiResult(
		useApiClient("roles").updateRole(role.value)
	);

	if (response.isOk()) {
		emit("update-role", response.value);
	}

	isSaving.value = false;
};
</script>

<template>
	<module-loading>
		<v-card class="mt-5 pa-5">
			<VForm>
				<v-text-field
					:label="t('roles.overview.modal.inputName')"
					variant="filled"
					clearable
					v-model="role.name"
					:rules="titleInputRules(t)"
				/>
				<v-textarea
					variant="filled"
					counter
					:label="t('roles.overview.modal.inputDescription')"
					v-model="role.description"
					:rules="[required(t), maxLength(t, 255)]"
					maxlength="255"
					auto-grow
					rows="3"
				/>
				<span>
					<v-btn color="primary" :disabled="isSaving" @click="updateRole">
						{{ $t("roles.detail.actionSave") }}
					</v-btn>
				</span>
			</VForm>
		</v-card>
	</module-loading>
</template>

<style lang="scss">
.v-expansion-panel-title__overlay {
	background: rgba(var(--v-theme-primary)) !important;
}
</style>
